// extracted by mini-css-extract-plugin
module.exports = {"access-agreement":"AccessAgreementPage-access-agreement--31yVU","title":"AccessAgreementPage-title--3Y8PQ"};